export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/fl.dc0cc60f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};